// extracted by mini-css-extract-plugin
module.exports = {"statsRow":"StatsLayout_statsRow__2rW6x"};